import { cn } from '@/lib/utils'
import { DollarCircleIcon, GraphIcon } from '@/components/dashboard/icons'

interface LeaderboardRow {
	rank: number
	name: string
	avatar: string
	staked: string
	share: string
	tierColor: string
}

const LEADERBOARD_ROWS: LeaderboardRow[] = [
	{
		rank: 1,
		name: 'WhiskerWizard',
		avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/0fb012a4ba0611b6640f9222584642f21d5dead8?width=48',
		staked: '1.44M',
		share: '$ 719,45',
		tierColor: 'bg-warning',
	},
	{
		rank: 2,
		name: 'PurrfectPal',
		avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/84290c58be35305b18de9a6562583cea0b5f5f36?width=48',
		staked: '1.39M',
		share: '$ 695,30',
		tierColor: 'bg-muted-foreground',
	},
	{
		rank: 3,
		name: 'FelineFrenzy',
		avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/c594ee0653d616ec7b21eb5292d4aa4531b732ae?width=48',
		staked: '1.08M',
		share: '$ 672,24',
		tierColor: 'bg-warning/60',
	},
	{
		rank: 4,
		name: 'CatnipChampion',
		avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/4a0e225a8602b6eba9e616bac75453911e9bbf5d?width=48',
		staked: '947K',
		share: '$ 598,98',
		tierColor: 'bg-subtle-foreground',
	},
	{
		rank: 5,
		name: 'MeowMaster',
		avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/9a9e8e96c7e2efa6ec9a33a56f225f44168afc64?width=48',
		staked: '897K',
		share: '$ 509,09',
		tierColor: 'bg-subtle-foreground',
	},
	{
		rank: 6,
		name: 'Paw-someBuddy',
		avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/f65b8eb3b9ebb0412f7fb2fe2e9e5603e1ec7cba?width=48',
		staked: '821K',
		share: '$ 473,64',
		tierColor: 'bg-subtle-foreground',
	},
	{
		rank: 7,
		name: 'KittyConnoisseur',
		avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/a37f6d0830054fae16f31e816debe59de2c058af?width=48',
		staked: '756K',
		share: '$ 462,02',
		tierColor: 'bg-subtle-foreground',
	},
	{
		rank: 8,
		name: 'TabbyTornado',
		avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/d18a315de039f5c68b3226eb446142042cf0110d?width=48',
		staked: '732M',
		share: '$ 448,88',
		tierColor: 'bg-subtle-foreground',
	},
]

interface FeedItem {
	icon: typeof GraphIcon
	name: string
	action: string
	detail?: string
	amount: string
	time: string
	colorClass: string
	gradientClass: string
}

const FEED_ITEMS: FeedItem[] = [
	{
		icon: GraphIcon,
		name: 'Lucky Player',
		action: 'Won',
		detail: 'Crash',
		amount: '1 234,56 USDT',
		time: '29m ago',
		colorClass: 'text-warning border-warning/24',
		gradientClass: 'from-warning to-warning/70',
	},
	{
		icon: DollarCircleIcon,
		name: 'Whale Staker',
		action: 'Staked',
		amount: '50 000 USDT',
		time: '42m ago',
		colorClass: 'text-purple border-purple/24',
		gradientClass: 'from-[hsl(var(--accent-purple))] to-purple',
	},
	{
		icon: DollarCircleIcon,
		name: 'Reward Hunter',
		action: 'Claimed',
		amount: '567,89 USDT',
		time: '2h ago',
		colorClass: 'text-success border-success/24',
		gradientClass: 'from-[hsl(var(--accent-green))] to-success',
	},
	{
		icon: GraphIcon,
		name: 'Card Shark',
		action: 'Bet',
		detail: 'Blackjack',
		amount: '100 SOL',
		time: '7h ago',
		colorClass: 'text-info border-info/24',
		gradientClass: 'from-[hsl(var(--accent-blue))] to-info',
	},
	{
		icon: GraphIcon,
		name: 'Bitcoin Baron',
		action: 'Won',
		detail: 'Roulette',
		amount: '0,025000 BTC',
		time: '1d ago',
		colorClass: 'text-warning border-warning/24',
		gradientClass: 'from-warning to-warning/70',
	},
]

export function LeaderboardAndLiveFeed() {
	return (
		<section className='grid grid-cols-1 items-stretch gap-4 lg:grid-cols-4'>
			<div className='flex h-full min-w-0 flex-col gap-4 rounded-[14px] border border-border bg-card p-4 shadow-[0_4px_12px_0_hsl(var(--background)/0.2)] lg:col-span-3'>
				<div className='flex shrink-0 items-center justify-between'>
					<h3 className='text-lg font-medium tracking-[-0.27px] text-foreground'>Staking Holders Leaderboard</h3>
					<a href='#' className='flex items-center gap-1.5 text-base font-semibold tracking-[-0.24px] text-primary'>
						View all
						<svg width='20' height='20' viewBox='0 0 20 20' fill='none'>
							<path d='M6 13.5L13.5 6M13.5 13V6H6.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='bevel' />
						</svg>
					</a>
				</div>

				<div className='flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl bg-background'>
					<div className='grid shrink-0 grid-cols-[56px_1fr_100px_60px_100px] gap-2 border-b border-border px-4 py-2 text-xs font-medium text-subtle-foreground sm:grid-cols-[56px_1fr_120px_80px_120px]'>
						<span>Rank</span>
						<span>User Name</span>
						<span className='text-right'>Staked</span>
						<span className='text-center'>Tier</span>
						<span className='text-right'>Daily Share</span>
					</div>
					<div className='min-h-0 flex-1 overflow-y-auto'>
						{LEADERBOARD_ROWS.map((row, i) => (
							<div
								key={row.name}
								className={cn(
									'grid grid-cols-[56px_1fr_100px_60px_100px] items-center gap-2 px-4 py-2.5 sm:grid-cols-[56px_1fr_120px_80px_120px]',
									i % 2 === 1 && 'bg-foreground/[0.03]',
								)}
							>
								<span className='text-sm text-subtle-foreground'>{row.rank}</span>
								<span className='flex items-center gap-3 text-sm text-foreground'>
									<img src={row.avatar} alt='' className='h-6 w-6 rounded-full border border-border object-cover' />
									<span className='truncate'>{row.name}</span>
								</span>
								<span className='text-right text-sm font-semibold text-warning'>{row.staked}</span>
								<span className='flex justify-center'>
									<span className={cn('h-3 w-3 rounded-full', row.tierColor)} />
								</span>
								<span className='text-right text-sm font-semibold text-primary'>{row.share}</span>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className='flex h-full min-w-0 flex-col gap-4 rounded-[14px] border border-border bg-card p-4 shadow-[0_4px_12px_0_hsl(var(--background)/0.2)] lg:col-span-1'>
				<h3 className='shrink-0 text-lg font-medium tracking-[-0.27px] text-foreground'>Live feed</h3>
				<div className='flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto rounded-2xl bg-background p-3'>
					{FEED_ITEMS.map((item, i) => (
						<div key={i} className={cn('flex items-center gap-4 rounded-lg border px-4 py-2.5', item.colorClass)}>
							<span className={cn('flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gradient-to-b text-foreground', item.gradientClass)}>
								<item.icon className='h-5 w-5' />
							</span>
							<div className='flex flex-1 flex-col gap-0.5'>
								<span className='text-sm text-foreground'>{item.name}</span>
								<span className='flex items-center gap-1.5 text-xs'>
									<span className={item.colorClass.split(' ')[0]}>{item.action}</span>
									{item.detail ? (
										<>
											<span className='h-1 w-1 rounded-full bg-subtle-foreground/40' />
											<span className='text-muted-foreground'>{item.detail}</span>
										</>
									) : null}
								</span>
							</div>
							<div className='flex flex-col items-end gap-0.5'>
								<span className='text-sm font-medium text-foreground'>{item.amount}</span>
								<span className='text-xs text-subtle-foreground'>{item.time}</span>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	)
}
